module.exports = __webpack_public_path__ + "static/beetroot-54b1a804c459014ea4cadac9c451049b.png";